export type ShapeKind =
  | "arch"
  | "ball"
  | "cube"
  | "pyramid"
  | "rectangle-side"
  | "rectangle-upright";

export type ShapeColor =
  | "coral"
  | "pink"
  | "blue"
  | "yellow"
  | "red"
  | "purple"
  | "teal";

export function shapeAsset(kind: ShapeKind, color: ShapeColor): string {
  return `/shapes/${kind}-${color}.png`;
}
